import type { Client, ClientStatus } from '../domain/entities/Client.js';
import type { Order } from '../domain/entities/Order.js';

/**
 * Derived per the product rules:
 *   green  → monthly target met
 *   yellow → recent purchase but below target
 *   red    → no purchases this year / dormant
 *
 * Per-client monthly target is approximated as (annual target / 12).
 * When per-client targets become a real source, replace the divisor.
 */
export function classifyClient(
  client: Client,
  orders: Order[],
  annualTargetPerClientEUR: number,
  now: Date = new Date(),
): ClientStatus {
  const yearStart = new Date(Date.UTC(now.getUTCFullYear(), 0, 1));
  const monthStart = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1));

  let revenueThisMonth = 0;
  let hadPurchaseThisYear = false;
  for (const o of orders) {
    if (o.clientId !== client.id) continue;
    const t = new Date(o.date).getTime();
    if (t >= yearStart.getTime()) hadPurchaseThisYear = true;
    if (t >= monthStart.getTime()) revenueThisMonth += o.totalEUR;
  }

  if (!hadPurchaseThisYear) return 'red';
  const monthlyTarget = annualTargetPerClientEUR / 12;
  return revenueThisMonth >= monthlyTarget ? 'green' : 'yellow';
}
